import React, { useContext, useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import ReactPaginate from "react-paginate";

import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { fetch_orders, fetch_sub_orders, get_order_details, get_user_details, sub_order_update } from '../api/api';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../context/Context';
import Loader from '../Loader/Loader';
import { DatePicker, Space, Typography } from 'antd';
import moment from 'moment';
import { toast } from 'react-toastify';
import FormError from '../components/FormError';
import { Box } from '@mui/material';
import DateRange from '../components/DateRange';
const { RangePicker } = DatePicker;


function SubOrders() {
    const [subOrderList, setSubOrderList] = useState([]);

    const location = useLocation();
    const orderId = location.state?.orderId;
    const add_close_Ref = useRef(null);
    const [asignOrderValue, setAsignOrderValue] = useState({
        sub_order_id: '',
        sub_order_date: '',
        user_id: '',
        status: '',
    });
    const [userList, setUserList] = useState([]);
    const [orderDetails, setOrderDetails] = useState({ order_no: '' });
    const { loader, setLoader, dateFormate } = useContext(MyContext);
    const [statusFilter, setStatusFilter] = useState('');
    const [deliveryBoyFilter, setDeliveryBoyFilter] = useState(0);
    const [dateFilter, setDateFilter] = useState({
        start_date: '',
        end_date: ''
    })
    const [isFiltered, setIsFiltered] = useState(false);
    // const today = new Date().toISOString().slice(0, 10);
    const [formError, setFormError] = useState({
        user_id: ''
    })


    // today sub order 
    const [nextFilterDate, setNextFilterDate] = useState(location.state?.filter == 'nextday' ? true : false);
    const [filterDate, setFilterDate] = useState(location.state?.filter ? true : false);
    const today = nextFilterDate
        ? new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10);


    // tomorrow sub order
    const [tomorrowFilterDate, setTomorrowFilterDate] = useState(location.state?.tomorrowSubOrder == 'tomorrow-day' ? true : false);
    const tomorrow = tomorrowFilterDate
        ? new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10);


    useEffect(() => {
        fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date, filterDate, tomorrowFilterDate);
        fetch_user_list();
    }, [statusFilter, deliveryBoyFilter, filterDate, tomorrowFilterDate])


    // fetch sub ouder api
    const fetch_sub_orders_api = async (startDate, endDate, filterDate, tomorrowFilterDate) => {
        const filter = {};


        if (startDate && endDate) {
            filter.start_date = startDate;
            filter.end_date = endDate;
        }

        if (filterDate) {
            filter.start_date = today
            filter.end_date = today;
            setDateFilter({
                start_date: today,
                end_date: today
            });
            setIsFiltered(true)
        }

        if (tomorrowFilterDate) {
            filter.start_date = tomorrow
            filter.end_date = tomorrow;
            setDateFilter({
                start_date: tomorrow,
                end_date: tomorrow
            });
            setIsFiltered(true)
        }
        filter.order_id = orderId ? orderId : '';
        filter.status = statusFilter ? statusFilter : '';
        filter.user_id = deliveryBoyFilter ? deliveryBoyFilter : '';

        setLoader(true);
        try {
            const res = await fetch_sub_orders(filter);
            if (res.status === 200) {
                setSubOrderList(res.data.data);
            }
            setLoader(false);
        } catch (error) {
            console.error("Order List Api error:", error);

        }
    };


    const fetch_user_list = async () => {
        setLoader(true);
        try {
            const res = await get_user_details({ user_type: 'delivery_boy' })
            if (res.status === 200) {
                setUserList(res.data.data);
            }
            setLoader(false);
        } catch (error) {
            console.error("User List Api error:", error);
        }
    }


    const handleFilter = (dates, dateStrings) => {
        if (dateStrings[0] && dateStrings[1]) {
            // If both dates are selected, apply filter
            setDateFilter({
                start_date: moment(dateStrings[0]).format('YYYY-MM-DD'),
                end_date: moment(dateStrings[1]).format('YYYY-MM-DD'),
            });
        } else {
            // If no dates are selected, reset filter
            setDateFilter({ start_date: '', end_date: '' });
            if (isFiltered) {
                fetch_sub_orders_api('', '', false)
                setFilterDate(false)
                setIsFiltered(false);
                setTomorrowFilterDate(false);
            }
        }
    };


    const applyFilter = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setIsFiltered(true);
            fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date, false);
        }
    }


    const asign_order = (order) => {
        setAsignOrderValue({ ...asignOrderValue, sub_order_id: order.sub_order_id, user_id: order.user_id, tomorrowFilterDate, status: order.status })
        setOrderDetails(order);
    }
    const change_order_date = async () => {
        try {
            const res = await sub_order_update(asignOrderValue);
            if (res.data.status == 200) {
                add_close_Ref.current.click();
                fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date);
                setAsignOrderValue({ ...asignOrderValue, sub_order_date: '' })
                toast.success("Order Date Updated Scuccessfully")
            }
        } catch (error) {
            console.error("Asign Order Api error:", error);
        }
    }

    const handleOnChange = (e) => {
        setAsignOrderValue({ ...asignOrderValue, [e.target.name]: e.target.value })
    }

    //save changes
    const saveChanges = async () => {

        const errors = {};

        if (!asignOrderValue.user_id) {
            errors.user_id = 'Please Select Delivery Boy!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }

        try {
            const res = await sub_order_update(asignOrderValue)
            if (res.data.status == 200) {
                add_close_Ref.current.click();
                fetch_sub_orders_api(dateFilter.start_date, dateFilter.end_date);
                toast.success("Order Assign Scuccessfully")
            }

        } catch (error) {
            console.error("Asign Order Api error:", error);
        }
    }

    // data table 
    // useEffect(() => {
    //     setTimeout(() => {
    //         const tableId = '#example2';
    //         const table = $(tableId);

    //         if ($.fn.DataTable.isDataTable(tableId)) {
    //             table.DataTable().destroy();
    //         }

    //         // Initialize DataTable with scrollX for horizontal scrolling
    //         table.DataTable({
    //             paging: true,
    //             lengthChange: false,
    //             pageLength: 10,
    //             lengthMenu: [5, 10, 15, 20],
    //             searching: false,
    //             ordering: false,
    //             // info: true,
    //             autoWidth: false,
    //             // infoFiltered: "(filtered from _MAX_ total records)",
    //             pagingType: 'full_numbers',
    //             language: {
    //                 paginate: {
    //                     first: '«',
    //                     last: '»',
    //                     next: '›',
    //                     previous: '‹',
    //                 }
    //             },
    //             drawCallback: function (settings) {
    //                 const api = this.api();
    //                 const info = api.page.info();
    //                 const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
    //                 const currentPage = info.page;
    //                 const totalPages = info.pages;

    //                 // Show only specific pages with ellipses
    //                 $paginate.each(function (index) {
    //                     const pageIndex = parseInt($(this).text(), 10) - 1;
    //                     if (isNaN(pageIndex)) return; // Skip non-number buttons

    //                     if (
    //                         pageIndex === 0 ||
    //                         pageIndex === totalPages - 1 ||
    //                         (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
    //                     ) {
    //                         $(this).show();
    //                     } else {
    //                         $(this).hide();
    //                     }
    //                 });

    //                 // Add ellipses if necessary
    //                 if (currentPage > 2) {
    //                     $('<span class="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
    //                 }
    //                 if (currentPage < totalPages - 3) {
    //                     $('<span class="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
    //                 }
    //             }
    //         });

    //         return () => {
    //             if ($.fn.DataTable.isDataTable(tableId)) {
    //                 table.DataTable().destroy();
    //             }
    //         };
    //     }, 800);
    // }, [subOrderList]);

    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }


    // custome pagination 
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const offset = (currentPage - 1) * itemsPerPage;
    const currentItems = subOrderList.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(subOrderList.length / itemsPerPage);


    const handlePageChange = (event, page) => {
        setCurrentPage(page);
    };

    const onFocus = () => {
        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
            setDateFilter({ start_date: '', end_date: '' });  // Reset state when focus happens
        }
    }

    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Sub Orders</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Sub Orders</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    loader ? <Loader /> : (
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Sub Order List</h3>
                                            </div>
                                            <div className="card-body">
                                                <div className='row mb-3 d-flex '>
                                                    <div className='mb-3 d-flex align-items-center'>
                                                        <div className='mr-2'>Date :</div>
                                                        <div className='mr-3'>
                                                            {/* <Space direction="horizontal" size={12}>
                                                                <RangePicker
                                                                    onChange={handleFilter}
                                                                    onFocus={() => {
                                                                        if (dateFilter.start_date !== '' && dateFilter.end_date !== '') {
                                                                            setDateFilter({ start_date: '', end_date: '' });  // Reset state when focus happens
                                                                        }
                                                                    }}
                                                                    size="large"
                                                                    value={[
                                                                        dateFilter.start_date ? moment(dateFilter.start_date) : '',
                                                                        dateFilter.end_date ? moment(dateFilter.end_date) : '',
                                                                    ]}
                                                                    inputReadOnly
                                                                />
                                                            </Space> */}
                                                            <DateRange handleFilter={handleFilter} onFocus={onFocus} value={[
                                                                dateFilter.start_date ? moment(dateFilter.start_date) : '',
                                                                dateFilter.end_date ? moment(dateFilter.end_date) : '',
                                                            ]} />

                                                        </div>
                                                        <div className='mr-4'>
                                                            <button
                                                                type="button"
                                                                className="btn btn-naariyal-green"
                                                                onClick={applyFilter}
                                                            >
                                                                Filter
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className='mb-3 mr-4 d-flex align-items-center'>
                                                        <div className='mr-2'>
                                                            Status :
                                                        </div>
                                                        <div >
                                                            <select
                                                                className="custom-select"
                                                                name="status"
                                                                onChange={(e) => setStatusFilter(e.target.value)}
                                                                value={statusFilter}
                                                            >
                                                                <option value="">All</option>
                                                                <option value="pending">Pending</option>
                                                                <option value="out_for_delivery">Out For Delivery</option>
                                                                <option value="delivered">Delivered</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='mb-3 mr-3 d-flex align-items-center'>
                                                        <div className='mr-2'>
                                                            Delivery Boy :
                                                        </div>
                                                        <div>
                                                            <select
                                                                className="custom-select"
                                                                name="user_id"
                                                                value={deliveryBoyFilter}
                                                                onChange={(e) => setDeliveryBoyFilter(e.target.value)}
                                                            >
                                                                <option value="">All</option>
                                                                <option value="none">None</option>
                                                                {userList && userList.map((user, index) => (
                                                                    <option value={user?.id} key={index} >{user?.username}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive">
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Order No</th>
                                                                <th>Date</th>
                                                                <th>Delivery Boy</th>
                                                                <th>Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currentItems.length > 0 ? (
                                                                currentItems.map((subOrder, index) => (
                                                                    <tr key={index}>
                                                                        <td>{subOrder.order_no}</td>
                                                                        <td>{dateFormate(subOrder?.sub_order_date)}</td>
                                                                        <td>{subOrder?.firstname || subOrder?.lastname ? `${subOrder.firstname} ${subOrder.lastname}` : " - "}</td>
                                                                        <td>
                                                                            {(() => {
                                                                                if (subOrder.status === "out_for_delivery") {
                                                                                    return <span className="badge badge-secondary text-sm">Out For Delivery</span>;
                                                                                } else if (subOrder.status === "delivered") {
                                                                                    return <span className="badge badge-success text-sm">Delivered</span>;
                                                                                } else {
                                                                                    return <span className="badge badge-warning text-sm">Pending</span>;
                                                                                }
                                                                            })()}
                                                                        </td>
                                                                        <td style={{ width: "205px" }}>
                                                                            <div className="btn-group">
                                                                                <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">
                                                                                    Action
                                                                                </button>
                                                                                <div className="dropdown-menu" role="menu">
                                                                                    <a
                                                                                        className="dropdown-item text-info"
                                                                                        data-toggle="modal"
                                                                                        data-backdrop="static"
                                                                                        data-target="#asignOrder"
                                                                                        onClick={() => asign_order(subOrder)}
                                                                                    >
                                                                                        <i className="nav-icon fas fa-pencil mr-2"></i>
                                                                                        Assign Order
                                                                                    </a>
                                                                                    {subOrder.status !== "delivered" ?
                                                                                        <>
                                                                                            <div className="dropdown-divider"></div>
                                                                                            <a
                                                                                                className="dropdown-item text-info"
                                                                                                data-toggle="modal"
                                                                                                data-backdrop="static"
                                                                                                data-target="#changeOrderDate"
                                                                                                onClick={() => asign_order(subOrder)}
                                                                                            >
                                                                                                <i className="nav-icon far fa-calendar mr-2"></i>
                                                                                                Change Date
                                                                                            </a>
                                                                                        </>
                                                                                        : ""}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={5}>
                                                                        <span>No data available</span>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>

                                                    {/* Pagination Section */}
                                                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                                        {/* Page Info */}
                                                        <Typography variant="body2">
                                                            Showing {offset + 1} to {Math.min(offset + itemsPerPage, subOrderList.length)} of {subOrderList.length} entries
                                                        </Typography>

                                                        {/* Pagination Controls */}
                                                        <Stack spacing={2}>
                                                            <Pagination
                                                                count={Math.ceil(subOrderList.length / itemsPerPage)}
                                                                page={currentPage}
                                                                onChange={handlePageChange}
                                                                color="primary"
                                                                variant="outlined"
                                                                shape="rounded"
                                                                showFirstButton
                                                                showLastButton
                                                            />
                                                        </Stack>
                                                    </Box>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* assign order modal */}
                            <div className="modal fade" id="asignOrder" tabIndex={-1} role="dialog" aria-labelledby="orderDetailsModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>Assign Order</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                                onClick={() => {
                                                    clearError()
                                                    setAsignOrderValue({ ...asignOrderValue, user_id: '' })
                                                }
                                                }
                                                ref={add_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group">
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Mobile No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='mobile_no'
                                                            value={orderDetails.mobile_no || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div >
                                                        <label htmlFor="area_name">Customer Name</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='customer_name'

                                                            value={orderDetails?.customer_firstname + " " + orderDetails?.customer_lastname || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="area_name">Delivery Address</label>
                                                    <textarea
                                                        type=""
                                                        style={{ fontSize: "14px" }}
                                                        rows={4}
                                                        className="form-control"
                                                        name='delivery_address'

                                                        value={orderDetails.delivery_address || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Order No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='delivery_address'
                                                            value={orderDetails.order_no || ''}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className=''>
                                                        <label htmlFor="area_name">Date</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='delivery_address'
                                                            value={dateFormate(orderDetails.sub_order_date)}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100'>
                                                    <label htmlFor="">Select Status</label>
                                                    <div>
                                                        <select
                                                            className="custom-select"
                                                            name="status"
                                                            value={asignOrderValue.status || ''}
                                                            onChange={handleOnChange}
                                                        >
                                                            <option value="">Select Status...</option>
                                                            <option value="pending">Pending</option>
                                                            <option value="out_for_delivery">Out For Delivery</option>
                                                            <option value="delivered">Delivered</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className='w-100'>
                                                    <label htmlFor="">Select Delivery Boy</label>
                                                    <div>
                                                        <select
                                                            className="custom-select"
                                                            name="user_id"
                                                            value={asignOrderValue.user_id || ''}
                                                            onChange={handleOnChange}

                                                        >
                                                            <option value="">Select Delivery Boy...</option>
                                                            {userList && userList.map((user, index) => (
                                                                <option value={user?.id} key={index} >{user?.username}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <FormError>
                                                        {formError.user_id ? formError.user_id : ''}
                                                    </FormError>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">
                                            <button
                                                type="button"
                                                className="btn btn-naariyal-green w-25 m-auto"
                                                onClick={saveChanges}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* change order date modal */}
                            <div className="modal fade" id="changeOrderDate" tabIndex={-1} role="dialog" aria-labelledby="changeOrderDate" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>Change Order Date</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                                onClick={() => {
                                                    clearError()
                                                    setAsignOrderValue({ ...asignOrderValue, user_id: '' })
                                                }
                                                }
                                                ref={add_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group">
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Order No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='mobile_no'
                                                            value={orderDetails.order_no || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="area_name">Order Date</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='customer_name'
                                                            value={dateFormate(orderDetails?.sub_order_date) || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div className='pr-3'>
                                                        <label htmlFor="area_name">Mobile No</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='mobile_no'
                                                            value={orderDetails.mobile_no || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="area_name">Customer Name</label>
                                                        <input
                                                            type=""
                                                            className="form-control"
                                                            name='customer_name'

                                                            value={orderDetails?.customer_firstname + " " + orderDetails?.customer_lastname || ""}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className="w-100 mb-3 d-flex" style={{ height: "1px", backgroundColor: "#e9ecef" }}></div>
                                                <div className='w-100 mb-3 d-flex'>
                                                    <div>
                                                        <label htmlFor="new_order_date">New Order Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name='new_order_date'
                                                            value={asignOrderValue.sub_order_date || ""}
                                                            onChange={(e) => {
                                                                setAsignOrderValue({ ...asignOrderValue, sub_order_date: e.target.value })
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">
                                            <button
                                                type="button"
                                                className="btn btn-naariyal-green w-25 m-auto"
                                                onClick={() => change_order_date()}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </section>
                    )
                }
            </div>

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div >
    );
}

export default SubOrders;
